import { render, staticRenderFns } from "./Summary.vue?vue&type=template&id=187fb17d&scoped=true&"
import script from "./Summary.vue?vue&type=script&lang=js&"
export * from "./Summary.vue?vue&type=script&lang=js&"
import style0 from "./Summary.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./Summary.vue?vue&type=style&index=1&id=187fb17d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "187fb17d",
  null
  
)

export default component.exports